import { Link } from "react-router-dom";

const PrivacyPolicyFooter = () => {
  window.scrollTo(0, 0);
  return (
    <>
      <div className="container mt-4 mb-5">
        <h2 className="text-center text-primary-new fw-bold mb-4">
          Privacy Policy
        </h2>

        <p className="text-dark">
          Reachello.com and their subdomains, and including for purchase and/or
          use of our services or products, you are deemed to have read and
          agreed to the following privacy policy:
        </p>

        <h4 className="text-primary-new fw-bold">Terminology</h4>

        <p className="text-dark">
          The following terminology applies to this Privacy Policy, our Terms
          and Conditions found at{" "}
          <Link
            to="/terms-conditions"
            className="text-primary fw-bold text-decoration-none"
          >
            Terms and Conditions
          </Link>
          , and any or all Agreements between us: “Client”, “User”, “You” and
          “Your” refers to you, the person accessing this website and accepting
          the Company's Terms and Conditions. In case the person accessing this
          website is doing so on behalf of an organization such as a business,
          municipality, company, or other group, “Client”, “You” and “Your”
          refers to both you personally as well as the organization you are
          representing. Furthermore, by representing an organization on this
          website, you affirm that you have the authority to enter into
          agreements on behalf of that organization. “Company”, “Our”,
          “Ourselves”, “We” and “Us”, refers to Next Health Media LLC, d/b/a
          Reachello, a OHIO company. “Party”, “Parties”, or “Us”, refers to both
          the Client and ourselves when plural, or either the Client or
          ourselves when singular. “Services” and “Products” refer to anything
          that we offer for you to use or consume, including services which may
          be registered for online but may be accessed, at least in part,
          offline. “Website” and “Site” refer to content, software,
          applications, and services accessed on or through our domain,
          reachello.com, including any subdomains. Any use of the above
          terminology or other words in the singular, plural, capitalization
          and/or he/she or they, are taken as interchangeable if not otherwise
          defined separately and therefore as referring to same.
        </p>

        <h4 className="text-primary-new fw-bold">Who are we?</h4>

        <p className="text-dark">
          Next Health Media LLC, which does business as Reachello, provides a
          website and platform which allows businesses and individuals to order
          and receive services related to employment screening, drug testing,
          DNA testing, background check, occupational health, and other items.
          This Privacy Policy explains how we collect, share, and utilize
          personal information about you. “Personal Information” refers to any
          information that we collect that may identify an individual, such as a
          name, address, etc.
        </p>

        <h4 className="text-primary-new fw-bold">
          What Information do we Collect?
        </h4>

        <p className="text-dark">
          We collect information from you when you register on our site, place
          an order, subscribe to our newsletter, call our offices, use our
          software applications, utilize our services offline, respond to a
          survey, fill out a form, and in a number of other ways. When ordering
          or registering on our site, as appropriate, you may be asked to enter
          your: name, e-mail address, mailing address, phone number, credit card
          information or other information that is required to schedule you
          and/or provide you with the service(s) that you request. If you
          register for a service and then avail yourself of that service
          offline, additional personal information may be collected at that
          time. You may, however, visit our site anonymously.
        </p>

        <h4 className="text-primary-new fw-bold">Privacy Statement</h4>

        <p className="text-dark">
          We are committed to protecting your privacy. Authorized employees
          within the company, and third parties who partner with us including
          but not limited to: laboratories, medical review officers, drug
          testing technicians, third party software vendors, breath alcohol
          technicians, DNA collection sites, etc., will have access to
          information collected from clients. We regularly review our systems
          and data to ensure the best possible service to our customers.{" "}
        </p>

        <h4 className="text-primary-new fw-bold">Confidentiality</h4>

        <div className="text-dark">
          <p>
            We regard the personally identifiable information of our clients as
            confidential, and as such, we do not sell or rent personally
            identifiable information to third parties. However, trusted third
            parties such as those who assist us in operating our website,
            conducting our business, or servicing you, may collect or receive
            your personal information from you or us. We may also release your
            information when we believe release is appropriate to comply with
            the law, enforce our site policies, or protect ours or others
            rights, property, or safety.
          </p>

          <p>
            Non-personally identifiable visitor information may be provided to
            other parties for marketing, advertising, or other uses.
            Additionally, clients have the right to request copies of their own
            records, which we will provide in a reasonable amount of time. We
            require proof of identity, such as a valid driver's license, before
            releasing certain records. Clients are requested to retain copies of
            any literature issued in relation to the provision of our services.
          </p>
        </div>

        <h4 className="text-primary-new fw-bold">
          Sharing and Release of Information
        </h4>

        <div className="text-dark">
          <p>
            A crucial part of the services that we offer is connecting various
            parties and allowing them to obtain services and share reports that
            contain personally identifiable information - such as the results of
            drug tests, background checks, or occupational health services -
            with one another. As such, by using our services, you are hereby
            authorizing us to share your information with another entity or
            requesting that another entity shares their information with you. At
            various times, you may be the party requesting another party's
            information (the “requestor”), or the party authorizing the sharing
            of your information (the “sharer”), or both. Reachello acts in the
            role of technology connector, processing the data (including
            connecting you with third party providers of services) and providing
            a mechanism for that data to flow between the requestor and the
            sharer.
          </p>

          <p>
            If and when you are the requestor, such as a business requesting a
            job applicant to undergo a pre-employment test, you are responsible
            for obtaining explicit authorization from the sharer to allow us to
            share their information with you.
          </p>

          <p>
            If and when you are the sharer, such as when you are requested to
            take a test by another entity or when you give us the name and
            contact information of another entity to share your information
            with, you are explicitly authorizing us to share your information
            with the requestor and/or any other parties that you specify to us
            verbally or in writing.
          </p>

          <p>
            Once data is shared, it becomes subject to the privacy practices of
            the entity to which it was shared.
          </p>
        </div>

        <h4 className="text-primary-new fw-bold">
          What do we use your information for?
        </h4>

        <div className="text-dark">
          <p>
            Any of the information we collect from you may be used in one of the
            following ways, or in other manners similar to those described here:
          </p>
          <ul>
            <li>To personalize your experience</li>
            <li>To improve our website</li>
            <li>To improve customer service</li>
            <li>To process transactions</li>
            <li>To provide you with services</li>
            <li>To provide you with reports including results of services</li>
            <li>To administer a promotion, survey or other site feature</li>
            <li>To send periodic emails</li>
          </ul>
          <p>
            We will send transactional emails to you related to the provision of
            services and orders, including status updates, invoices, and the
            like. Additionally, if you do not opt out or unsubscribe, you may
            receive occasional promotional emails from us with company news,
            promotions, related products or service information, or the like.
            Unsubscribing to promotional emails will not stop transactional
            emails from being sent, but you can control whether or not to
            receive certain transactional emails by letting us know your
            preferences.
          </p>
          <p>
            Your information, whether public or private, will not be sold,
            exchanged, transferred, or given to any other company for any reason
            whatsoever, without your consent, other than for the express purpose
            of delivering the purchased product or service requested.
            Notwithstanding the foregoing, we may also disclose your information
            in connection with a corporate re-organization, a merger or
            amalgamation with another entity, a sale of all or a substantial
            portion of our assets or stock, including any due diligence exercise
            carried out in relation to the same, provided that the information
            disclosed continues to be used for the purposes permitted by this
            Privacy Policy by the entity acquiring the information.
          </p>
        </div>

        <h4 className="text-primary-new fw-bold">
          How do we protect your information?
        </h4>

        <div className="text-dark">
          <p>
            We implement a variety of security measures to maintain the safety
            of your personal information when you place an order or enter,
            submit, or access your personal information. Any personally
            identifiable sensitive information or payment information is
            transmitted via Secure Socket Layer (SSL) technology to our
            server(s). We encrypt payment information for transmittal to our
            gateway provider(s) and/or merchant processor(s). Unfortunately,
            however, no data transmission can be guaranteed to be 100% secure.
            We cannot, therefore, warrant or ensure the security of any
            information you transmit to us or from our products or services, and
            you do so at your own risk.
          </p>
        </div>

        <h4 className="text-primary-new fw-bold">User Submitted Content</h4>

        <div className="text-dark">
          <p>
            We may provide opportunities for users to submit content to us, such
            as commenting on our blog articles or reviewing our products. If
            such content is submitted by you, it is not considered confidential.
            However, you may request that we remove it from our site, and we
            generally honor such requests expeditiously.
          </p>
        </div>

        <h4 className="text-primary-new fw-bold">Do we use cookies?</h4>

        <div className="text-dark">
          <p>No</p>
        </div>

        <h4 className="text-primary-new fw-bold">Contacting Us</h4>

        <div className="text-dark">
          <p>
            If there are any questions regarding this privacy policy you may
            <Link
              to="/contact-us"
              className="text-primary fw-bold text-decoration-none"
            >
              {" "}
              contact us
            </Link>{" "}
            using the information below.
          </p>

          <p>
            You may also send an email to our staff at{" "}
            <a href="#" className="text-primary fw-bold text-decoration-none">
              support@reachello.com
            </a>
            .
          </p>
        </div>

        <h4 className="text-primary-new fw-bold">
          Changes to our Privacy Policy
        </h4>

        <div className="text-dark">
          <p>
            This Privacy Policy may be amended, modified, varied or supplemented
            by duly authorized representatives of the Company. If changes are
            made, we will post those changes on this page and update the date of
            last modification below.
          </p>
        </div>
        <br />

        <h5 className="text-primary-new fw-bold">Date of Last Modification</h5>

        <h5 className="text-primary-new fw-bold">December 5,2022</h5>
      </div>
    </>
  );
};

export default PrivacyPolicyFooter;
